import dayjs from 'dayjs';

import { REPORTS_START_DATE } from 'src/shared/constants';

export const getReportsVersions = () => {
  const versionsOptions: {
    value: string;
    label: string;
  }[] = [];
  const currentDate = dayjs();
  let date = dayjs(REPORTS_START_DATE);

  while (date.isBefore(currentDate)) {
    versionsOptions.push({
      value: date.format('YYYY-MM-DD'),
      label: date.format('MMMM YYYY'),
    });
    date = date.add(1, 'month');
  }

  return [...versionsOptions].reverse();
};
